// The catalog supplies the rules transcribed from Min_Max_Ma_C3_9Fe_(2).xlsx.
export const fittingCode = keyword => (keyword ?? '').split(' - ')[0].trim()
  .replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').toUpperCase();

export default {
  data: () => ({ fittingOversizeWarning: false, fittingDimensionNoticeStepId: null, priceOnRequest: false }),
  computed: {
    selectedFittingDimensionRule() {
      const article = this.articleLists.find(item => String(item.id) === String(this.selectedArticle));
      const code = fittingCode(this.searchTextArticle);
      return article?.dimension_rules?.[code] ?? article?.dimension_rules?.[code.replace(/-XL$/, '')] ?? null;
    },
  },
  methods: {
    getFittingDimensionFields() {
      const root = this.$refs.dynamicContent;
      const rule = this.selectedFittingDimensionRule;
      if (!root || !rule) return { width: null, heightInputs: [], ramWidths: [], wings: [] };
      const active = input => {
        const step = input.closest('[id^="s_"]');
        return !step || (!this.isStepHidden(step)
          && !this.filteredStepItems.find(item => `s_${item.id}` === step.id)?.isHiddenByRule);
      };
      const find = (scope, selectors) => selectors.flatMap(selector => Array.from(scope.querySelectorAll(selector))).find(active);
      const width = find(root, rule.basis === 'RAM'
        ? ['.rm_b_value', '.min_value.x_value:not(.lm_b_value)']
        : ['.zam_b_value', '.zm_z_b_value', '.rm_b_value', '.stulp_width',
          '.min_value.x_value:not(.lm_b_value):not(.rm_z_b_value)', '.rm_z_b_value:not(.lm_b_value)']);
      const scope = width?.closest('[id^="s_"]') || root;
      const height = find(scope, ['.zam_h_value', '.zm_z_h_value', '.rm_h_value', '.rm_z_h_value',
        '.min_value.y_value:not(.f_r_value):not(.wing_r_value)']);
      const sumInputs = Array.from(scope.querySelectorAll('[data-price-y-sum]')).filter(active);
      const heightInputs = sumInputs.length > 1 ? sumInputs : [height].filter(Boolean);
      const ramWidths = rule.ram_min_width == null ? []
        : Array.from(root.querySelectorAll('.rm_b_value, .wing_l_value, .wing_r_value, .gangfluegel_value')).filter(active);
      const wings = rule.sheet === 'P20' && / Stulp$/i.test(this.searchTextArticle.split(' - ')[0])
        ? Array.from(root.querySelectorAll('.f_l_value, .f_r_value')).filter(active) : [];
      return { width, heightInputs, ramWidths, wings };
    },
    getFittingDimensionBounds(input) {
      const rule = this.selectedFittingDimensionRule;
      if (!rule || !input) return null;
      const { width, heightInputs, ramWidths, wings } = this.getFittingDimensionFields();
      if (input === width) return { min: rule.min_width, max: rule.max_width };
      if (heightInputs.length === 1 && input === heightInputs[0]) return { min: rule.min_height, max: rule.max_height };
      if (ramWidths.includes(input)) return { min: rule.ram_min_width, max: rule.ram_max_width };
      if (wings.includes(input)) return { min: rule.min_width / 2, max: rule.max_width / 2 };
      // LM and computed RAM heights are intermediate measurements. The workbook
      // limits apply to the final measurement, including the sum used by BG 825.
      if (input.matches('.min_value.x_value, .min_value.y_value, [data-price-y-sum]')) return { min: 0, max: null };
      return null;
    },
    validateFittingDimensions() {
      const rule = this.selectedFittingDimensionRule;
      if (!rule) {
        this.fittingOversizeWarning = false;
        this.fittingDimensionNoticeStepId = null;
        return true;
      }
      const { width, heightInputs, ramWidths, wings } = this.getFittingDimensionFields();
      this.fittingDimensionNoticeStepId = width?.closest('[id^="s_"]')?.id ?? null;
      let valid = true;
      const check = (inputs, value, min, max) => {
        const invalid = value !== null && (value < min || value > max);
        inputs.forEach(input => this.setDimensionInputError(input, invalid));
        if (invalid) valid = false;
      };
      const widthValue = this.getNumericInputValue(width);
      const heightValue = this.getAggregateInputSum(heightInputs);
      check([width].filter(Boolean), widthValue, rule.min_width, rule.max_width);
      check(heightInputs, heightValue, rule.min_height, rule.max_height);
      ramWidths.forEach(input => check([input], this.getNumericInputValue(input), rule.ram_min_width, rule.ram_max_width));
      wings.forEach(input => check([input], this.getNumericInputValue(input), rule.min_width / 2, rule.max_width / 2));
      const oversizeWidths = rule.oversize_width_basis === 'RAM' && ramWidths.length
        ? ramWidths.map(input => this.getNumericInputValue(input)) : [widthValue];
      this.fittingOversizeWarning = oversizeWidths.some(value => value !== null && value >= rule.oversize_width)
        || (heightValue !== null && heightValue >= rule.oversize_height);
      return valid;
    },
  },
};
